module.exports = __webpack_public_path__ + "img/ph.21aa7033.svg";